import React from 'react'
import styled from 'styled-components'
import Layout from '../../components/Layout'
import { useParams } from 'react-router-dom'
import { useRequest } from '../../fetchboi/hooks'
import { motion } from 'framer-motion'
import Header from './Header'
import Biography from './Biography'
import Program from './Program'

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05
    }
  }
}

export default function SpeakerDetail () {
  const { id } = useParams()
  const [speaker, loading] = useRequest({ url: `/speakers/${id}?include=Activities` })

  return (
    <Layout.Container>
      <Layout.Loader loading={loading}/>
      {speaker && (
        <motion.div variants={containerVariants} initial="hidden" animate="visible">
          <Header
            imageURL={speaker.PhotoURL}
            name={`${speaker.FirstNames} ${speaker.LastNames}`}
            position={speaker.Position}
          />
          <Biography biography={speaker.Biography}/>
          {speaker.Included && <Program activities={speaker.Included.Activities} />}
        </motion.div>
      )}

    </Layout.Container>
  )
}

const Container = styled.div`
  
`